import CalendarioReservas from './CalendarioReservas.vue';
import FormReserva from './FormReserva.vue';

export default {
  install: (app, _options) => {
    app.component('CalendarioReservas', CalendarioReservas)
      .component('FormReserva', FormReserva);
  },
};
